// ============================================
// Path: /frontend/src/pages/admin/ContentPage.jsx
// Purpose: Admin page to manage static content pages
// ============================================

// ========================================
// IMPORTS
// ========================================
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Button } from '../../components/ui/button';
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

// ========================================
// CONSTANTS
// ========================================
const staticPages = [
  { name: 'About Us', path: '/about' },
  { name: 'Contact Us', path: '/contact' },
  { name: 'Terms of Service', path: '/terms' },
  { name: 'Privacy Policy', path: '/privacy' },
];

// ========================================
// MAIN COMPONENT
// ========================================
export default function ContentPage() {
  console.log('🎨 [ContentPage] Component mounted');

  // ========================================
  // RENDER
  // ========================================
  return (
    <Card>
      <CardHeader>
        <CardTitle>Content Management</CardTitle>
        <CardDescription>
          Manage the content of your site's static pages. Currently, page content must be edited directly in the source code.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Page Name</TableHead>
              <TableHead>Path</TableHead>
              <TableHead className="text-center">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {staticPages.map((page) => (
              <TableRow key={page.path}>
                <TableCell className="font-medium">{page.name}</TableCell>
                <TableCell>{page.path}</TableCell>
                <TableCell className="text-center">
                  <Link to={page.path} target="_blank" rel="noopener noreferrer">
                    <Button variant="ghost" size="icon" title="View Page">
                      <Eye className="h-4 w-4" />
                    </Button>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}